export default __webpack_public_path__ + "static/media/1913.a0b8baf6.png";